import { render, staticRenderFns } from "./UnmarkedTests.vue?vue&type=template&id=5bd045c3&"
import script from "./UnmarkedTests.vue?vue&type=script&lang=js&"
export * from "./UnmarkedTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports